import { FC, useState } from 'react'
import { Alert, Button, Modal } from 'antd'
import Task from '../../../types/api/task'
import { FormsSetOrdersEditor } from './forms-set-orders-editor/forms-set-orders-editor'

interface CompleteFormsOrderProps {
    task: Task
}

const CompleteFormsOrder: FC<CompleteFormsOrderProps> = ({ task }) => {
    const [open, setOpen] = useState(false)

    return (
        <>
            <Button
                type='primary'
                onClick={() => setOpen(true)}
                disabled={task.taskStatus === 'Завершена'}
            >
                Завершить
            </Button>

            <Modal
                width={1000}
                title={task.type === 'Перезаказ форм' ? 'Перезаказ форм' : 'Задача заказа форм'}
                open={open}
                footer={null}
                // До save черновик в памяти — закрытие его просто бросает.
                // После save заказ уже на сервере, повторно откроется по formOrderId.
                onCancel={() => setOpen(false)}
                destroyOnClose
            >
                {task.description && <Alert message={task.description} type='info' />}
                <FormsSetOrdersEditor
                    task={task}
                    formSet={task.shipment?.form_set}
                    onSuccess={() => setOpen(false)}
                />
            </Modal>
        </>
    )
}

export default CompleteFormsOrder
